import { Radio, RadioGroup } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

export type RubricSelectionValue = "USE_DEFAULT" | "SELECT_EXISTING";

export interface RubricSelectionRadioGroupProps {
  value: RubricSelectionValue;
  onChange: (value: RubricSelectionValue) => void;
}

export function RubricSelectionRadioGroup({
  value,
  onChange,
}: RubricSelectionRadioGroupProps) {
  const { t } = useTranslation();

  return (
    <RadioGroup
      isCard
      isRequired
      label={t("Select one")}
      value={value}
      onChange={(value) => onChange(value as RubricSelectionValue)}
      aria-label="rubric-selection-radio-group"
    >
      <Radio
        testID="use-default-scoring-radio"
        value="USE_DEFAULT"
        aria-label="use-default-scoring-radio"
        description={t(
          "No rubric is applied. Results are delivered as-is, without custom scoring rules."
        )}
      >
        {t("Use default scoring")}
      </Radio>
      <Radio
        testID="select-existing-rubric-radio"
        value="SELECT_EXISTING"
        aria-label="select-existing-rubric-radio"
        description={t(
          "Select from your pre-created rubrics to apply custom scoring rules to this package."
        )}
      >
        {t("Apply a rubric")}
      </Radio>
    </RadioGroup>
  );
}
